import { useUtmSource } from '@/utils/hooks';

const UtmSource = () => {
  useUtmSource();
  return null;
};

export default UtmSource;
